const SELECTOR = '[data-advanced-filter-presets-toggle]';
const $FIELDSET = $('[data-advanced-filter-presets-fieldset]');
const $CACHE_FIELDSET = $('[data-filter-presets-cache]');

class AdvancedFilterPresets {
  constructor() {
    if ($(SELECTOR)) {
      this.attachEventHandlers();
      this.toggleFieldsetChanges();
    }
  }

  useFiltersPresetsChecked() {
    return $(SELECTOR).is(':checked');
  }

  attachEventHandlers() {
    $(SELECTOR).on('change', () => {
      if (this.useFiltersPresetsChecked()) {
        this.toggleFieldsetChanges();
        this.useSearchPreferencesCache();
      } else {
        this.clearFieldsValues();
      }

      this.applySearchPreferences();
    });
  }

  clearFieldsValues() {
    $FIELDSET
      .find('input[type="checkbox"]')
      .removeAttr('checked')
      .end()
      .find('select')
      .val('')
      .trigger('change');
  }

  toggleFieldsetChanges() {
    $FIELDSET.toggleClass('disable-events', this.useFiltersPresetsChecked());
  }

  applySearchPreferences() {
    $FIELDSET.closest('form').trigger('submit');
  }

  useSearchPreferencesCache() {
    $CACHE_FIELDSET.removeAttr('disabled');
  }
}

export default AdvancedFilterPresets;



// WEBPACK FOOTER //
// ./src/javascripts/AdvancedFilterPresets.js